import * as Yup from 'yup';
export const initialChildValues = {
    allergies: '',
    disabilities: '',
    otherHealthConditions: '',
    homeLanguageIds: [],
    otherLanguages: '',
};
export const childSchema = Yup.object().shape({
    allergies: Yup.string(),
    disabilities: Yup.string(),
    otherHealthConditions: Yup.string(),
    otherLanguages: Yup.string(),
});
//# sourceMappingURL=child.js.map